import { render, staticRenderFns } from "./EditClass.vue?vue&type=template&id=205eccd0&scoped=true&"
import script from "./EditClass.vue?vue&type=script&lang=js&"
export * from "./EditClass.vue?vue&type=script&lang=js&"
import style0 from "./EditClass.vue?vue&type=style&index=0&id=205eccd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205eccd0",
  null
  
)

export default component.exports